<template>
  <div>
    <!-- Start banner -->
    <services-banner></services-banner>
    <!-- End banner -->
    <div
      class="services-content">
      <v-layout
        :style="$vuetify.breakpoint.mdAndUp ? 'padding-left: 5vw; padding-right: 5vw':'padding-left: 10vw;'"
        class="services-categories-layout"
        row
        justify-center
        wrap>
        <v-flex        
         :style="$vuetify.breakpoint.mdAndUp ? '':'margin-bottom: 40px'"
          xs12
          sm12
          md4>
          <div
           :style="$vuetify.breakpoint.smAndUp ? '':'margin-left: 5% !important'"
            class="service-category-wrapper">
            <p
              class="service-number">
              01
            <p>
            <p
              class="service-name">
              Gastroenterología Quirúrgica
            </p>
          </div>
        </v-flex>
        <v-flex
         :style="$vuetify.breakpoint.mdAndUp ? '':'margin-bottom: 40px'"
          xs12
          sm12
          md4>
          <div
           :style="$vuetify.breakpoint.smAndUp ? '':'margin-left: 5% !important'"
            class="service-category-wrapper">
            <p
              class="service-number">
              02
            <p>
            <p
              class="service-name">
              Cirugia General y Laparoscopia
            </p>
          </div>
        </v-flex>
        <v-flex
         :style="$vuetify.breakpoint.mdAndUp ? '':'margin-bottom: 40px'"
          xs12
          sm12
          md4>
          <div
           :style="$vuetify.breakpoint.smAndUp ? '':'margin-left: 5% !important'"
            class="service-category-wrapper">
            <p
              class="service-number">
              03
            <p>
            <p
              class="service-name">
              Colorectal Protologia
            </p>
          </div>
        </v-flex>
      </v-layout>
      <v-layout
        style="background-color: white; padding: 40px 5% 40px 5%"
        row
        wrap>
        <v-flex
          v-for="item in items"
          :key="item.title"
          class="treatment-items-flex"
          xs12
          sm6
          md4>
          <div
            class="treatment-wrapper">
            <img
              :alt="'foto-' + item.title"
              :src="item.image" 
              class="treatment-image">
            <div
              class="treatment-name">
              <p
                class="treatment-name-text">
                {{item.title}}
              </p>
            </div>
            <div
              class="treatment-description">
              <p
                class="treatment-description-text">
                {{item.description}}
              </p>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    items: [
      {
        title: "Hernia",
        description: "Las hernias son un defecto de la integridad de la pared abdominal que provocan dolor.",
        image: "/img/static/hernia.png"
      },
      {
        title: "Piedras Vesicula",
        description: "Las piedras vesiculares son cálculos que aparecen en la vesícula biliar.",
        image: "/img/static/piedras.png"
      },
      {
        title: "Acidez",
        description: "Es una sensación de ardor o quemante, justo debajo o detrás del esternón o en la ‘boca del estómago’.",
        image: "/img/static/acidez.png"
      },
      {
        title: "Reflujo",
        description: "Es el regreso del contenido del estómado hacia el esófago, por más de dos veces en una semana.",
        image: "/img/static/reflujo.png"
      },
      {
        title: "Diverticulos",
        description: "Son pequeñas hernias ubicadas en la pared del colon, que pueden provocar inflamación, hemorragia, o ‘colitis’.",
        image: "/img/static/diverticulos.png"
      },
      {
        title: "Hemorroides",
        description: "Las hemorroides son dilataciones varicosas (várices) de las venas del ano o la ruptura de una de ellas.",
        image: "/img/static/hemorroides.png"
      },
      {
        title: "Fisura Anal",
        description: "Es la presencia de una o varias heridas (cortadas) en la región del borde del ano.",
        image: "/img/static/fisuras.png"
      },
      {
        title: "Cancer",
        description: "El cáncer del aparato digestivo es variado, de alta frecuencia y prevalencia.",
        image: "/img/static/cancer.png"
      },
    ]
  }),
  components: {
    // banner
    ServicesBanner: () => import('@/components/Services/Banner.vue'),
  }
}
</script>
<style scoped>
  .treatment-items-flex {
    max-width: 88%;
    padding-left: 6%;
    margin-bottom: 30px
  }
  .treatment-name {
    min-height: 20px;
    max-height: 20px;
    margin: 5px 0px 5px 0px;
    overflow: hidden;
  }
  .treatment-name-text {
    color: black;
    font-family: 'Montserrat', sans-serif;
    font-size: 20px;
    text-align: left;
    font-weight: 700;
  }
  .treatment-description-text {
    color: black;
    font-family: 'Montserrat', sans-serif;
    font-size: 13px;
    text-align: left;
    font-weight: 500;
    max-width: 90%;
  }
  .treatment-description {
    min-height: 50px;
    max-height: 50px;
    margin: 10px 0px 10px 0px;
    overflow: hidden;
  }
  .treatment-image {
    display: flow-root;
    margin-bottom: 8px;
    max-height: 60px !important
  }
  .treatment-wrapper {
    border-bottom-style: solid;
    border-bottom-color: black;
    border-bottom-width: 2px;
    padding-bottom: 8px;
  }
  .service-category-wrapper {
    max-width: 60%;
    margin-left: 20%;
  }
  .services-categories-layout {
    background-color: white; 
    padding-bottom: 40px; 
    padding-top: 80px;
  }
  .service-number {
    color: #98B7F8;
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    text-align: left;
    font-weight: 700;
  }
  .service-name {
    color: black;
    font-family: 'Montserrat', sans-serif;
    font-size: 30px;
    text-align: left;
    font-weight: 600;
    line-height: 40px;
  }
  .content-polygon {
    margin-bottom: -1px;
    z-index: 2;
    position: relative;
    background-color: white;
    clip-path: polygon(0 0,100% 100%,100% 0,100% 10%,100% 100%,0 100%);
    height: 150px;
    width: 100%;
  }
  .services-content {
    z-index: 2;
    max-width: 100vw;
    overflow: hidden;
    padding-top: 100vh;
    position: relative;
  }
</style>